<template>
  <div>
    <div class="user_body">
      <div class="top_nav">
        <span class="title" >售后服务</span>
      </div>

      <div class="search_top">
        <div class="tabs">
          <span :class="navIndex == 6 ? 'tab_select' : 'tab_nselect'" @click="navClick2(6)">全部</span>
          <span class="s_line">|</span>
          <span :class="navIndex == 4 ? 'tab_select' : 'tab_nselect'" @click="navClick2(4)">处理中({{orderIndex.count4}})</span>
          <span class="s_line">|</span>
          <span :class="navIndex == 5 ? 'tab_select' : 'tab_nselect'" @click="navClick2(5)">已完成({{orderIndex.count5}})</span>
        </div>
        <el-input placeholder="输入产品名称、订单号" suffix-icon="el-icon-search" v-model="keyword" class="input"
          size="small"></el-input>
      </div>

      <div class="order_list" v-loading="loading">
        <div class="order_item" v-for="(item, index) in orderList" :key="index">
          <div class="o_t">
            <span class="title2">{{ item.refund_status==-1?'待确认':item.refund_status==0?'处理中':item.refund_status==1?'已驳回':'已通过'}}</span>
            <div class="order_top">
              <span class="o_text1">{{ item.createtime}}&nbsp;&nbsp;|&nbsp;&nbsp;订单号：{{ item.order_no}}</span>
            </div>
          </div>
          <div class="order_info_list">
            <div class="order_info_item" v-for="(goods, index) in item.order_goods" :key="index">
              <img :src="goods.goods.thumb" class="order_img">
              <div class="order_name_pr">
                <span class="o_text3">{{ goods.goods.title}}</span>
                <span class="o_text4">{{goods.sku.price||goods.goods.price}}元&nbsp;&nbsp;&nbsp;X&nbsp;{{goods.goods.total}}</span>
              </div>
              <div class="order_btns">
                <span class="order_btns2" @click="goServiceInfo(item)">服务单详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
export default {
  name: "SuggestionsView",
  data() {
    return {
      currentPage1: 1,
      total: 10,
      colors: ["#FF921D", "#FF921D", "#FF921D"],
      navIndex: 6,
      keyword: '',
      loading: false,
      orderList: [],
      orderIndex: {},
    };
  },
  created() {
    this.getOrderList();
    this.getOrderIndex();
  },
  mounted() { },
  methods: {
    getOrderIndex() {

      this.$api.orderRefundCount().then(res => {
        console.log(res);
        if (res.code == 1) {
          this.orderIndex = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getOrderList() {
      this.loading = true;
      this.$api.getOrderList({
        status: this.navIndex,
        page: this.currentPage1,
        keyword: this.keyword,
        limit: 10
      }).then(res => {
        console.log(res);
        this.loading = false;
        if (res.code == 1) {
          this.orderList = res.data.list;
          this.total = res.data.total;
        } else {
          this.orderList = [];
        }
      }).catch(err => {
        console.log(err);
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });

    },
    navClick2(index) {
      this.navIndex = index;
      this.keyword = '';
      this.currentPage1 = 1;
      this.getOrderList();
    },
  
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    goServiceInfo(item) {
      this.$router.replace({ path: "/serviceinfo/" + item.id });
    }
  }
};
</script>

<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}

.top_nav {
  display: flex;
  flex-direction: row;
}

.title {
  color: #757575;
  font-size: 16px;
  width: 120px;
}

.title2 {
  color: #999999;
  font-size: 16px;
  width: 120px;
  margin-left: 20px;
  margin-top: 20px;
}

.search_top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.tabs {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}

.input {
  width: 200px;
}

.tab_select {
  cursor: pointer;
  color: #3c9c8f;
  font-size: 14px;
}

.tab_nselect {
  cursor: pointer;
  color: #666666;
  font-size: 14px;
}

.s_line {
  margin-left: 15px;
  margin-right: 15px;
  size: 12px;
  color: #999999;
}

.order_item {
  border: 1px solid #f1f1f1;
  margin-top: 10px;
}

.o_t {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.order_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  border-bottom: 1px solid #f1f1f1;
  padding: 10px 20px 10px 20px;
}

.o_text1 {
  color: #757575;
  font-size: 14px;
}

.o_text2 {
  color: #3c9c8f;
  font-size: 28px;
}

.o_text3 {
  color: #333333;
  font-size: 14px;
  width: 90%;
}

.o_text4 {
  color: #666666;
  font-size: 14px;
  width: 90%;
}

.o_text5 {
  color: #3c9c8f;
  font-size: 28px;
  border: 1px solid #3c9c8f;
  margin-top: 10px;
}

.order_info_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.order_info_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
}

.imae_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px 10px 30px;
  box-sizing: border-box;
}

.order_img {
  width: 80px;
  height: 80px;
}

.order_name_pr {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  margin-left: 20px;
}

.order_name_pr span:nth-child(odd) {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}

.order_name_pr span:nth-child(even) {
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}

.order_btns {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}

.order_btns1 {
  background: #3c9c8f;
  font-size: 14px;
  color: white;
  width: 100px;
  text-align: center;
  height: 25px;
  line-height: 25px;
}

.order_btns2 {
cursor: pointer;
  background: #ffffff;
  font-size: 14px;
  color: #757575;
  width: 100px;
  text-align: center;
  height: 23px;
  line-height: 25px;
  border: 1px solid #b0b0b0;
  margin-top: 10px;
}

.order_btns3 {
  background: #ffffff;
  font-size: 14px;
  color: #3c9c8f;
  width: 100px;
  text-align: center;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  border: 1px solid #3c9c8f;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
